<template>
  <RevCard class="p-16">
    <h3 class="heading-3 mb-16">
      {{ i18n(translations.orderDetails) }}
    </h3>

    <div
      v-for="orderLine in orderDetails.orderLines"
      :key="orderLine.id"
      class="mb-8 flex flex-row items-start justify-between"
    >
      <div class="pr-16">
        <div>{{ orderLine.productName }}</div>
        <div class="body-2">{{ orderLine.appearance.label }}</div>
      </div>
      <span class="body-1-bold">
        {{ i18n.price(orderLine.priceWithoutTaxes) }}
      </span>
    </div>

    <div class="mb-8 flex flex-row items-end justify-between">
      <span class="pr-16">{{ i18n(translations.shipping) }}</span>
      <span class="body-1-bold">
        + {{ i18n.price(orderDetails.shipping?.price) }}
      </span>
    </div>

    <div class="mb-8 flex flex-row items-end justify-between">
      <span class="pr-16">{{ i18n(translations.tax) }}</span>
      <span class="body-1-bold"> + {{ i18n.price(orderDetails.taxes) }} </span>
    </div>

    <RevDivider />

    <div class="my-8 flex flex-row items-end justify-between">
      <span class="pr-16">{{ i18n(translations.total) }}</span>
      <span class="body-1-bold"> + {{ i18n.price(orderDetails.price) }} </span>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevDivider } from '@ds/components/Divider'

import type { OrderDetails } from '../../OrderDetails.types'

import translations from './OrderDetails.translations'

defineProps<{ orderDetails: OrderDetails }>()

const i18n = useI18n()
</script>
